import { GraphQLClient, gql } from "graphql-request"
import { qraphqlEndpoint, gqlRequestArgs, stateObj, Lang, PaymentMethod, SignUpType } from "../const"
import React from "react"

export function gqlRequest(args: gqlRequestArgs) {
    const endpoint = args.endpoint ?? qraphqlEndpoint
    const headers = args.headers ?? {}
    const queryOrMutation: string = args.query
    const variables = args.variables || {}

    const client = new GraphQLClient(endpoint)
    client.setHeaders({ ...headers, userDiv: window?.navigator?.product + window?.navigator?.productSub })

    return client.request(queryOrMutation, variables)
}

export function userFieldExistance({ field, value }: { field: string; value: string }) {
    const query = gql`
        query userFieldExistance($field: Field!, $value: String!) {
            userFieldExistance(field: $field, value: $value)
        }
    `
    const variables = {
        field,
        value,
    }

    return gqlRequest({ query, variables })
        .then((res: { userFieldExistance: boolean }) => res.userFieldExistance)
        .catch((err: string) => {
            console.log(err)
            return err
        })
}

export function login(input: { email: string; password: string }) {
    const query = gql`
        query login($input: Login!) {
            login(input: $input) {
                authorized
                approved
                token
                id
                isAdmin
                lang
                firstName
                lastName
                email
                error
            }
        }
    `
    const variables = {
        input: {
            password: input.password,
            email: input.email,
        },
    }
    // console.log(variables)
    return gqlRequest({ query, variables }).then((res) => res.login)
}

export function signUp(input: SignUpType) {
    const query = gql`
        mutation SignUp($input: SignUpData!) {
            signUp(input: $input) {
                authorized
                approved
                token
                id
                isAdmin
                lang
                firstName
                lastName
                email
                error
            }
        }
    `
    const variables = {
        input: {
            password: input.password,
            email: input.email,
            lang: input.lang,
            firstName: input.firstName,
            lastName: input.lastName,
            hashedLink: input.hashedLink,
            method: input.method,
        },
    }
    // console.log(variables)
    return gqlRequest({ query, variables }).then((res) => res.signUp)
}

export function processTT(input: { email: string; payment_id: string; last4digit?: string }) {
    const query = gql`
        mutation processTT($input: TTData!) {
            processTT(input: $input) {
                json
                length
                error
                comment
            }
        }
    `
    const variables = {
        input: {
            payment_id: input.payment_id,
            email: input.email,
            last4digit: input.last4digit,
        },
    }
    // console.log(variables)
    return gqlRequest({ query, variables }).then((res) => res.processTT)
}

export function jwtAuth(token: string) {
    // console.log("%c!", "color:white;padding:.5em;background-color: black;",  token)
    const query = gql`
        query jwtAuth {
            jwtAuth {
                token
                authorized
                approved
                lang
                isAdmin
                firstName
                lastName
                email
                id
                error
            }
        }
    `
    const variables = {}
    return gqlRequest({ query, variables, headers: { token } }).then((res) => res.jwtAuth)
}

export function fetchLessons(token: string) {
    // console.log("%c!", "color:white;padding:.5em;background-color: black;",  token)
    const query = gql`
        query fetchLessons {
            fetchLessons {
                json
                length
                id
                error
                comment
            }
        }
    `
    const variables = {}

    return gqlRequest({ query, variables, headers: { token } }).then((res) => res.fetchLessons)
}

type persistPlaybackType = { lesson: number; completed?: boolean; time: number }
export function persistPlayback(token: string, { lesson, completed, time }: persistPlaybackType) {
    const query = gql`
        mutation persistPlayback($lesson: Int!, $completed: Boolean!, $time: Int!) {
            persistPlayback(lesson: $lesson, completed: $completed, time: $time) {
                json
                error
                comment
                length
                id
            }
        }
    `
    const variables = { lesson, completed, time }
    return gqlRequest({ query, variables, headers: { token } }).then((res) => res.persistPlaybackType)
}

export function getPersistedPlaybackState(token: string) {
    // console.log("%c!", "color:white;padding:.5em;background-color: black;",  token)
    const query = gql`
        query getPersistedPlaybackState {
            getPersistedPlaybackState {
                json
                length
                id
                error
                comment
            }
        }
    `
    const variables = {}
    return gqlRequest({ query, variables, headers: { token } }).then((res) => res.getPersistedPlaybackState)
}

export function setLastLessonListened(token: string, lesson: number) {
    // console.log("%c!", "color:white;padding:.5em;background-color: black;",  token)
    const query = gql`
        mutation setLastLessonListened($lesson: Int!) {
            setLastLessonListened(lesson: $lesson) {
                json
                error
                comment
                length
                id
            }
        }
    `
    const variables = { lesson }
    return gqlRequest({ query, variables, headers: { token } }).then((res) => res.setLastLessonListened)
}

export function createPracticeSet(token: string) {
    // console.log("%c!", "color:white;padding:.5em;background-color: black;",  token)
    const query = gql`
        mutation createPracticeSet {
            createPracticeSet {
                id
                json
                length
                error
                comment
            }
        }
    `
    const variables = {}
    return gqlRequest({ query, variables, headers: { token } }).then((res) => res.createPracticeSet)
}

type scorePracticeType = { token: string; filename: string; answer: "correct" | "wrong" }
export function scorePractice({ token, answer, filename }: scorePracticeType) {
    // console.log("%c!", "color:white;padding:.5em;background-color: black;",  token)
    const query = gql`
        mutation scorePractice($answer: Answer!, $filename: String!) {
            scorePractice(answer: $answer, filename: $filename) {
                json
                error
                comment
                length
                id
            }
        }
    `
    const variables = { answer, filename }
    return gqlRequest({ query, variables, headers: { token } }).then((res) => res.scorePractice)
}